













































import Vue from "vue";
import Component from "vue-class-component";
import { mapGetters } from "vuex";
import UsersTable from "./UsersTable.vue";
import CompanyTable from "./CompanyTable.vue";
import StoreTable from "./StoreTable.vue";
import RefreshTokenTable from "./RefreshTokenTable.vue";
import AllowedUserTable from "./AllowedUserTable.vue";

@Component({
  components: {
    UsersTable,
    CompanyTable,
    StoreTable,
    RefreshTokenTable,
    AllowedUserTable
  },
  computed: {
    ...mapGetters({
      users: "admin/users",
      companies: "admin/companies",
      stores: "admin/stores",
      refreshTokens: "admin/refreshTokens",
      allowedUsers: "admin/allowedUsers"
    })
  }
})
export default class AdminTab extends Vue {
  model: string = "";

  mounted() {}
}
